<template>
  <div class="pt-4">
    <recurrent-intervention-dialog
      v-model="isRecurrentInterventionDialogOpened"
      :inboxIntervention="recurrentInterventionInDialog"
      @refused="inboxInterventionRefused"
    />
    <new-recurrent-intervention-dialog
      v-model="isNewRecurrentInterventionDialogOpened"
      :maker="newRecurrentInterventionMaker"
      @added="fetchRecurrentInterventions"
    />
    <v-row no-gutters justify="center" align="center" class="pt-8" v-if="isFetchingRecurrentInterventions && !recurrentInterventions.length">
      <div>
        <v-progress-circular
          indeterminate
          color="accent"
        />
      </div>
    </v-row>
    <template v-else-if="recurrentInterventions.length">
      <template v-for="recurrentIntervention in recurrentInterventions">
        <recurrent-intervention-card
          :key="recurrentIntervention.id"
          :value="recurrentIntervention"
          clickable
          class="mb-4"
          @click="recurrentInterventionInDialog = recurrentIntervention"
        />
      </template>
    </template>
    <div class="pt-8" v-else>
      <v-row no-gutters justify="center" align="center">
        <v-icon large color="accent">task_alt</v-icon>
      </v-row>
      <v-row no-gutters justify="center" align="center" class="pt-2 font-weight-medium">
        Félicitations, vous avez traité toutes vos interventions récurrentes
      </v-row>
      <v-row no-gutters justify="center" align="center" class="pt-6">
        <v-btn :disabled="!$canWrite" class="n-small-btn n-primary-btn" @click="$canWrite && (isNewRecurrentInterventionDialogOpened = true)">
          En programmer une nouvelle ?
        </v-btn>
      </v-row>
      <v-row no-gutters justify="center" align="center" class="pt-4">
        <v-btn class="n-text-btn" to="/settings/recurrent-interventions">
          ou administrez toutes vos récurrences
        </v-btn>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import RecurrentInterventionCard from '@/components/RecurrentInterventions/Card.vue';
import RecurrentInterventionDialog from '@/components/Inbox/RecurrentInterventionDialog.vue';
import NewRecurrentInterventionDialog from '@/components/RecurrentInterventions/NewDialog.vue';

export default {
  data: () => ({
    isInitialLoading: false,
    recurrentInterventionInDialog: null,
    isNewRecurrentInterventionDialogOpened: false,
  }),

  computed: {
    ...mapState(`model/client`, [
      `company`,
    ]),
    ...mapGetters(`ui/inboxRecurrentInterventions`, [
      `recurrentInterventions`,
      `isFetchingRecurrentInterventions`,
    ]),
    ...mapGetters(`ui/mainLayout`, [
      `countInboxRecurrentInterventions`,
    ]),
    isRecurrentInterventionDialogOpened: {
      get() { return this.recurrentInterventionInDialog !== null; },
      set() { this.recurrentInterventionInDialog = null; },
    },
    newRecurrentInterventionMaker() {
      return this.company;
    },
  },

  methods: {
    ...mapActions(`ui/inboxRecurrentInterventions`, [
      `fetchRecurrentInterventions`,
    ]),
    inboxInterventionRefused() {
      this.isRecurrentInterventionDialogOpened = false;
      this.fetchRecurrentInterventions();
    },
  },

  watch: {
    countInboxRecurrentInterventions() {
      this.fetchRecurrentInterventions();
    },
  },

  async beforeMount() {
    this.isInitialLoading = true;
    await this.fetchRecurrentInterventions();
    this.isInitialLoading = false;
  },

  components: {
    RecurrentInterventionCard,
    RecurrentInterventionDialog,
    NewRecurrentInterventionDialog,
  },
};
</script>

<style lang="scss" scoped>
</style>
